import { render } from "./garment-hero.vue?vue&type=template&id=f6f5ee5a&scoped=true"
import script from "./garment-hero.vue?vue&type=script&lang=js"
export * from "./garment-hero.vue?vue&type=script&lang=js"

import "./garment-hero.vue?vue&type=style&index=0&id=f6f5ee5a&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6f5ee5a"]])

export default __exports__